<template>
  <div  :class="from!='introDetail'?'box4':'box4 no-padding'">
    <pageTitle
      title="拥抱AI变革<br/>学习使用AI技术做软件测试"
      text="AI驱动的测试对现代软件开发至关重要。传统测试方法已难以满足复杂软件系统的高效性和准确性需求。"
      titColor="#86909C"
    />

    <div class="subject-content">
      <swiper :options="swiperOption4" ref="mySwiperbox4" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index + 'box4'"
          :class="'swiperwrap' + index"
        >
          <div class="box">
            <div class="title" v-html="item.title"></div>
            <ul class="content">
              <li
                v-for="(itemInner, indexInner) in item.content"
                :key="indexInner"
              >
                <i></i>
                <p v-html="itemInner"></p>
              </li>
            </ul>
          </div>
        </swiper-slide>
      </swiper>
      <!-- <div class="swiper-pagination-box4"></div> -->
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() { this.from=this.getQueryString("from")},
  data() {
    return {
     from:'',
      list: [
        {
          title: 'AI驱动测试的 <b class="youyue">优越性</b>',
          content: [
            "<b>速度快</b>AI可以通过自动化工具自动生成和执行测试用例，大大缩短了测试周期",
            "<b>高覆盖率</b>AI可以通过分析代码结构、历史缺陷数据和用户行为模式，生成更多样化的测试用例，覆盖更多的场景和边界条件，减少遗漏",
            "<b>个性化测试</b>AI可以根据不同的用户群体和使用场景，生成个性化的测试用例，确保系统在各种情况下都能提供良好的用户体验 ",
            "<b>快速适应新技术</b>AI可以通过不断学习新的数据和模式，自动优化测试策略和方法，适应快速变化的技术环境",
          ],
        },
        {
          title: '人工测试的 <b class="juxian">局限性</b>',
          content: [
            "<b>耗时：</b>手动编写和执行测试用例需要大量时间和精力，尤其是对于大型复杂系统，测试周期可能会非常长",
            "<b>易出错：</b>人类容易疲劳，尤其是在重复性任务中，可能导致疏忽或遗漏某些关键测试场景",
            "<b>覆盖有限：</b>手动测试通常只能覆盖已知的场景，难以发现隐藏的缺陷或边界条件",
          ],
        },
      ],

      cur: 0,
      swiperOption4: {
        loop: false, // 循环模式选项
        slidesPerView: "auto",
        // centeredSlides: true,
        // paginationClickable: true,
        // spaceBetween: 20,
        // effect: "left",
        pagination: {
          el: ".swiper-pagination-box4",
        },
      },
    };
  },
};
</script>

<style lang="less" scoped>

/deep/ .course-text {
  padding: 0 36px;
}
.subject-content {
  position: relative;
  margin-top: 32px;
  padding: 0 12px 30px 12px;

  width: 100%;
  box-sizing: border-box;
}
.swiperwrap {
  width: 726px;
  height: 956px;

  box-sizing: border-box;
  .title {
    font-size: 32px;
    text-align: left;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #24375c;
    line-height: 44px;
    margin-bottom: 24px;
    /deep/ .juxian {
      color: #86909c;
      margin-left: 4px;
    }
    /deep/ .youyue {
      color: #3e8efe;
      margin-left: 4px;
    }
  }
  .content {
    li {
      display: flex;
      align-items: flex-start;

      justify-content: flex-start;
      margin-bottom: 24px;
      i {
        display: block;
        width: 8px;
        height: 8px;
        background: #4b90f9;
        border-radius: 8px;
        margin-right: 14px;
        margin-top: 16px;
      }
      p {
        text-align: left;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #86909c;
        flex: 1;
        line-height: 40px;
        /deep/ b {
          display: block;
          color: #3e8efe;
          font-size: 28px;
          margin-bottom: 4px;
        }
      }
    }
  }
}
.swiperwrap1 {
  .content {
    li {
      i {
        background: #5F6B79;
      }
      p {
        text-align: justify !important;
        display: inline-block;
        /deep/ b {
          color: #5F6B79;
        }
      }
    }
  }
}
.box4 {
  padding: 0 0 40px;
  box-sizing: border-box;
  width: 100%;
  background: url("../../../assets/coursePage/softwareTest/box4/bg.png")
    no-repeat;
  background-size: 100% 100%;
  background-origin: center bottom;

  .subject-box {
    margin: 40px auto 28px;
    position: relative;

    // padding-bottom: 22px;
    width: 100%;
    overflow: hidden;
    border-radius: 20px;
    overflow: hidden;
  }

  .swiper-pagination-box4 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 8px;
    transform: translate(-50%, 0px);
    height: 6px;
    background: rgba(75, 132, 250, 0.16);
    border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: rgba(75, 132, 250, 0.16);
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #4b84fa;
    border-radius: 3px;
  }

  .swiper-slide {
    width: 556px;
    height: 956px;
    background: url("../../../assets/coursePage/softwareTest/box4/bg01.png")
      no-repeat;
    background-size: 100% 100%;
    background-origin: center;

    box-sizing: border-box;
    .box {
      position: relative;

      padding: 60px 68px 64px 68px;

      width: 100%;
      height: 100%;
      box-sizing: border-box;
      img {
        width: 100%;
        height: auto;
        margin: 0;
      }
    }
    // .box:nth-child(2) {
    //   img {
    //     margin: 32px 0;
    //   }
    // }
    // .box:nth-child(3) {
    //   img {
    //     margin: 34px 0 16px;
    //   }
    // }
  }
}
.no-padding{
   padding-top: 80px;
}
.swiperwrap0 {
  background: url("../../../assets/coursePage/softwareTest/box4/bg01.png")
    no-repeat !important;
  background-size: contain !important;
  background-position: center !important;
}
.swiperwrap1 {
  background: url("../../../assets/coursePage/softwareTest/box4/bg02.png")
    no-repeat !important;
  background-size: contain !important;
  background-position: center !important;
}
</style>
